export const QUERY_KEYS = {
  user: (userId: string) => ['userId', userId] as const,

  companies: (userId: string) =>
    [...QUERY_KEYS.user(userId), 'companies'] as const,

  companiesList: (userId: string) =>
    [...QUERY_KEYS.companies(userId), 'list'] as const,
}
